import AuthService from '../services/auth.service';
import TokenService from '../services/token.service';

const user = JSON.parse(localStorage.getItem("user"));

const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    async RefreshToken({ commit }) {
      try {
        const refreshToken = TokenService.getLocalRefreshToken();
        if (!refreshToken) throw new Error("No refresh token available");

        const data = await AuthService.refreshToken(refreshToken);

        commit('refreshToken', data.accessToken);
        return data.accessToken;
      } catch (error) {
        commit('logout');
        throw error;
      }
    },

    // Mevcut küçük harfli action (varsa kullanan bozulmasın diye tutuyoruz ama işlevini düzelttik)
    refreshToken({ commit }, accessToken) {
      commit('refreshToken', accessToken);
    },

    login({ commit }, { email, password, authenticatorCode }) {
      return AuthService.login(email, password, authenticatorCode).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },

    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    refreshToken(state, accessToken) {
      state.status.loggedIn = true;
      state.user = { ...state.user, accessToken: accessToken };
    }
  }
};
